<template>
  <PgDrawerSearchTable
    class="drawer-search-table-batch-number-basic"
    ref="tableRef"
    :visible.sync="visible"
    :hideSelectAll="!multiple"
    :size="size"
    :showFooter="multiple"
    :is-selection="multiple"
    v-bind="$attrs"
    @on-ok="onOk"
    @cell-click="cellClick"
    @on-cancel="onCancel"
    @closed="closed"
  ></PgDrawerSearchTable>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { ref, watch } from 'vue'
import PgDrawerSearchTable from './drawer-search-table.vue'

const props = defineProps({
  value: {
    type: Boolean,
    default: true,
  },
  //是否多选
  multiple: {
    type: Boolean,
    default: true,
  },
  rowConfig: {
    type: Object,
    default: () => ({ keyField: 'id' }),
  },
  //是否禁用
  size: {
    type: [Number, String],
    default: 1440,
  },
})

const emit = defineEmits(['input', 'on-ok'])

const visible = ref(props.value)
watch(
  () => props.value,
  (value) => {
    visible.value = value
  }
)

watch(visible, () => {
  emit('input', visible.value)
})

const tableRef = ref(null)
const onOk = ({ data }) => {
  visible.value = false
  emit('on-ok', data.records)
}
const cellClick = ({ row }) => {
  if (!props.multiple) {
    visible.value = false
    emit('on-ok', row)
  }
}

const onCancel = () => {
  emit('on-cancel')
}

const closed = () => {
  emit('closed')
}
</script>
<style lang="scss">
@import '../style/drawer-search-table-batch-number-basic.scss';
</style>
